import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import { FeathersVuex } from "feathers-vuex";
Vue.use(FeathersVuex);

const req = require.context("store/feathers/services", true, /service.js$/);
const servicePlugins = req.keys().map((path) => req(path).default);

import auth from "store/feathers/feathers.auth";

import billing from "./billing";
import notification from "./notification";
import product from "./product";
import base from "./base";
import config from "store/config";
import ids from "store/ids";
import toggle from "store/toggle";
import terminal from "store/terminal";
import customer from "store/customer";

// import mjml from "store/mjml";

export default new Vuex.Store({
  plugins: [...servicePlugins, auth],
  state: {},
  mutations: {},
  actions: {},
  modules: {
    config,
    ids,
    toggle,
    base,
    notification,
    billing,
    product,
    terminal,
    customer,
  },
}); 
